import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVolumeoff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.75 4.597c0-1.635-2.044-2.377-3.093-1.122L7.224 7.58a.25.25 0 0 1-.191.09H5a2.75 2.75 0 0 0-2.75 2.75v3.5A2.75 2.75 0 0 0 5 16.67h2.056c.07 0 .138.03.186.082l3.46 3.825c1.075 1.187 3.048.427 3.048-1.174zm-1.942-.16a.25.25 0 0 1 .442.16v14.807a.25.25 0 0 1-.435.167l-3.461-3.825a1.75 1.75 0 0 0-1.298-.576H5c-.69 0-1.25-.56-1.25-1.25v-3.5c0-.69.56-1.25 1.25-1.25h2.033c.518 0 1.01-.23 1.342-.627z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.858 9.269a.75.75 0 0 1 0 1.06l-1.766 1.767 1.769 1.769a.75.75 0 0 1-1.06 1.06l-1.77-1.769-1.769 1.77a.75.75 0 0 1-1.06-1.061l1.768-1.77-1.766-1.766a.75.75 0 0 1 1.06-1.06l1.767 1.766 1.767-1.767a.75.75 0 0 1 1.06 0"
  }));
}
var IcVolumeoff = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeoff));

export { IcVolumeoff as I };
